// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_38gc-","picM":"_1xqOo"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Special/Gif/gif.scss
 ** module id = 446
 ** module chunks = 0
 **/